export interface ContactSettings {
  supportEmail: string;
}

export const DEFAULT_SUPPORT_EMAIL = "lingoshade@lsnlab.com";
